import Vue from "vue";
import AuthService from "@/configurations/authentications/auth";
import Router from "vue-router";
import Main from "@/components/main";
import Dashboard from "@/dashboard/index";
import Login from "@/authentications/login";
import Register from "@/authentications/register";
import Roles from "@/roles/role";
import ManageRoles from "@/roles/manageroles";
import updateRole from "@/roles/updaterole";
import roleModules from "@/modules/module";
import manageModules from "@/modules/managemodules";
import newPermission from "@/permissions/permission";
import managePermissions from "@/permissions/managepermissions";
import user from "@/users/user";
import manageusers from "@/users/manageusers";
import updateUser from "@/users/updateuser";
import userRoles from "@/userroles/userrole";
import userProfile from "@/profile/userprofile";
import product from "@/products/product";
import manageproducts from "@/products/manageproducts";
import updateproduct from "@/products/updateproduct";
import managestocks from "@/stocks/managestocks";
import manageproduct from "@/stocks/manageproduct";
import stock from "@/stocks/stock";
import managetransporters from "@/transporters/managetransporters";
import transporter from "@/transporters/transporter";
import updatetransporter from "@/transporters/updatetransporter";
import managetrucks from "@/trucks/managetrucks";
import trucks from "@/trucks/trucks";
import updatetruck from "@/trucks/updatetruck";
import manageaccounttypes from "@/accounttypes/manageaccounttypes";
import accounttype from "@/accounttypes/accounttype";
import pettycash from "@/pettycashes/pettycash";
import purchaseorder from "@/purchaseorders/purchaseorder";
import managepurchaseorders from "@/purchaseorders/managepurchaseorders";
import updatepurchaseorder from "@/goodsreceiving/updatepurchaseorder";
import managegoodsreceiving from "@/goodsreceiving/managegoodsreceiving";
import purchase from "@/purchases/purchase";
import managepurchases from "@/purchases/managepurchases";
import sale from "@/sales/sale";
import managesales from "@/sales/managesales";
import expenses from "@/expenses/expenses";
import manageexpenses from "@/expenses/manageexpenses";
import trucksales from "@/reports/trucksales";
import productsales from "@/reports/productsales";
import truckexpenses from "@/reports/truckexpenses";
import productpurchases from "@/reports/productpurchases";
import interchanges from "@/reports/interchanges";
import labour from "@/labour/labour";
import managelabourcharges from "@/labour/managelabourcharges";
import editlabour from "@/labour/editlabour";
import labourcharges from "@/reports/labourcharges";
import summary from "@/reports/summary";
import employeeattendances from "@/reports/employeeattendances";
import oil from "@/oils/oil";
import manageoilreceiving from "@/oils/manageoilreceiving";
import editnote from "@/goodsreceiving/editnote";
import interchange from "@/interchanges/interchange";
import manageinterchanges from "@/interchanges/manageinterchanges";
import Employee from "@/employees/employee";
import manageEmployees from "@/employees/manageemployees";
import updateEmployee from "@/employees/updateemployee";
import manageattendances from "@/attendances/manageattendances";
import invoice from "@/invoices/invoice";
Vue.use(Router);
const Auth = new AuthService();
const ifAuthenticated = (to, from, next) => {
  if (Auth.isLoggedIn()) {
    next();
    return;
  }
  next("/login");
};
const ifNotAuthenticated = (to, from, next) => {
  if (!Auth.isLoggedIn()) {
    next();
    return;
  }
  next("/dashboard");
};
const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      component: Main,
      children: [
        {
          path: "",
          component: Dashboard
        },
        {
          path: "/dashboard",
          name: "Dashboard",
          component: Dashboard,
          beforeEnter: ifAuthenticated
        }
      ]
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
      beforeEnter: ifNotAuthenticated
    },
    {
      path: "/register",
      name: "Register",
      component: Register
    },
    {
      path: "/dashboard",
      component: Main,
      children: [
        {
          path: "/role",
          name: "Roles",
          component: Roles
        },
        {
          path: "/managerole",
          name: "manageRoles",
          component: ManageRoles
        },
        {
          path: "/updateRole",
          name: "roleUpdate",
          component: updateRole
        },
        {
          path: "/newmodule",
          name: "newModule",
          component: roleModules
        },
        {
          path: "/managemodules",
          name: "manageModules",
          component: manageModules
        },
        {
          path: "/permission",
          name: "permissions",
          component: newPermission
        },
        {
          path: "/managepermissions",
          name: "managePermissions",
          component: managePermissions
        },
        {
          path: "/newuser",
          name: "user",
          component: user
        },
        {
          path: "/manageusers",
          name: "manageUsers",
          component: manageusers
        },
        {
          path: "/updateuser",
          name: "updateUser",
          component: updateUser
        },
        {
          path: "/userroles",
          name: "userRoles",
          component: userRoles
        },
        {
          path: "/profile",
          name: "profile",
          component: userProfile
        },
        {
          path: "/newproduct",
          name: "product",
          component: product
        },
        {
          path: "/manageproducts",
          name: "manageproducts",
          component: manageproducts
        },
        {
          path: "/updateproduct",
          name: "updateproduct",
          component: updateproduct
        },
        {
          path: "/managestocks",
          name: "managestocks",
          component: managestocks
        },
        {
          path: "/stock",
          name: "manageproduct",
          component: manageproduct
        },
        {
          path: "/addstock",
          name: "stock",
          component: stock
        },
        {
          path: "/managetransporters",
          name: "managetransporters",
          component: managetransporters
        },
        {
          path: "/newtransporter",
          name: "transporter",
          component: transporter
        },
        {
          path: "/updatetransporter",
          name: "updatetransporter",
          component: updatetransporter
        },
        {
          path: "/managetrucks",
          name: "managetrucks",
          component: managetrucks
        },
        {
          path: "/newTransportertruck",
          name: "trucks",
          component: trucks
        },
        {
          path: "/updatetruck",
          name: "updatetruck",
          component: updatetruck
        },
        {
          path: "/manageaccounttypes",
          name: "manageaccounttypes",
          component: manageaccounttypes
        },
        {
          path: "/newaccount",
          name: "accounttype",
          component: accounttype
        },
        {
          path: "/Allocations",
          name: "pettycash",
          component: pettycash
        },
        {
          path: "/newpurchaseorder",
          name: "purchaseorder",
          component: purchaseorder
        },
        {
          path: "/managepurchaseorders",
          name: "managepurchaseorders",
          component: managepurchaseorders
        },
        {
          path: "/receivegoods",
          name: "updatepurchaseorder",
          component: updatepurchaseorder
        },
        {
          path: "/managegoodsreceiving",
          name: "managegoodsreceiving",
          component: managegoodsreceiving
        },
        {
          path: "/editnote",
          name: "editnote",
          component: editnote
        },
        {
          path: "/newpurchase",
          name: "purchase",
          component: purchase
        },
        {
          path: "/managepurchases",
          name: "managepurchases",
          component: managepurchases
        },
        {
          path: "/newsale",
          name: "sale",
          component: sale
        },
        {
          path: "/managesales",
          name: "managesales",
          component: managesales
        },
        {
          path: "/newexpenses",
          name: "expenses",
          component: expenses
        },
        {
          path: "/manageexpenses",
          name: "manageexpenses",
          component: manageexpenses
        },
        {
          path: "/trucksales",
          name: "trucksales",
          component: trucksales
        },
        {
          path: "/productsales",
          name: "productsales",
          component: productsales
        },
        {
          path: "/truckexpenses",
          name: "truckexpenses",
          component: truckexpenses
        },
        {
          path: "/labourcharges",
          name: "labourcharges",
          component: labourcharges
        },
        {
          path: "/productpurchases",
          name: "productpurchases",
          component: productpurchases
        },
        {
          path: "/employeeattendances",
          name: "employeeattendances",
          component: employeeattendances
        },
        {
          path: "/newlabourcharge",
          name: "labour",
          component: labour
        },
        {
          path: "/managelabourcharges",
          name: "managelabourcharges",
          component: managelabourcharges
        },
        {
          path: "/editlabour",
          name: "editlabour",
          component: editlabour
        },
        {
          path: "/summary",
          name: "summary",
          component: summary
        },
        {
          path: "/newoil",
          name: "oil",
          component: oil
        },
        {
          path: "/manageoilreceiving",
          name: "manageoilreceiving",
          component: manageoilreceiving
        },
        {
          path: "/newinterchange",
          name: "interchange",
          component: interchange
        },
        {
          path: "/manageinterchanges",
          name: "manageinterchanges",
          component: manageinterchanges
        },
        {
          path: "/employee",
          name: "employee",
          component: Employee
        },
        {
          path: "/manageemployees",
          name: "manageEmployees",
          component: manageEmployees
        },
        {
          path: "/updateemployee",
          name: "employeeUpdate",
          component: updateEmployee
        },
        {
          path: "/manageattendances",
          name: "manageattendances",
          component: manageattendances
        },
        {
          path: "/interchanges",
          name: "interchanges",
          component: interchanges
        },
        {
          path: "/newinvoice",
          name: "invoice",
          component: invoice
        }
      ]
    }
  ]
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js